export default "__VITE_ASSET__DKJouHL4__"